import { render, staticRenderFns } from "./BatchOrder.vue?vue&type=template&id=79c54a8c"
import script from "./BatchOrder.vue?vue&type=script&lang=js"
export * from "./BatchOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports